export enum DictCodeEnmu {
    //客户类型
    CUSTOMER_TYPE = "customer-type",
    //客户属性
    CUSTOMER_ATTR = "customer-attr",
    //供应商类型
    SUPPLIER_TYPE = "supplier-type",

    //配件类型
    MATERIAL_TYPE = "material-type",
    //计量单位
    MATERIAL_UNIT = "unit",
    //品牌
    MATERIAL_BRAND = "material-brand",
    //发动机型号
    ENGINE_TYPE = "engine-type",

    //开户银行类型
    OPENBANK_TYPE = "account-bank",
    //账户类型
    ACCOUNT_TYPE = "account-type",
    //发票类型
    INVOICE_TYPE = "invoice-type-test",
    //发票状态
    INVOICE_STATUS = "invoice-status-test",
    //支付状态
    PAY_STATUS = "pay-status-test",
    PAY_STATUS1 = "pay-status",
    
    PAY_METHOD1 = "pay-method",//之前"pay-method",
    //支付方式
    PAY_METHOD = "pay-method",
    //经济实体
    BENTITY = "bentity",
    //核销状态
    WRITE_OFF_STATUS = "write-off-status-test",

    //采购单状态
    PURCHASE_STATUS = "purchase-status",
    //采购类型
    PURCHASE_TEPE = "purchase-type-test",
    //采购退货单状态
    PURCHASE_RETURN_STATUS = "purchase-return-status",

    //销售订单状态
    SALE_ORDER_STATUS = "sale-order-status",
    //销售价格类型
    SALE_PRICE_TYPE = "sale-price-type-test",
    //销售单状态
    SALE_STATUS = "sale-status",
    //销售退货单状态
    SALE_RETURN_STATUS = "sale-return-status",
    //销售类型
    SALE_TYPE = "sale-type",
    //维修类型
    REPAIR_TYPE = "service-type", //之前 "repair-type",
    //车辆类型
    VEHICLE_TYPE = "vehicle-type",
    //仓库类型
    CK_TYPE = "warehouse-type",//之前"ck",
    //采购单状态
    PURCHASE = "purchase",
    //采购单退货状态
    PURCHASE_RETURN = "purchase-return",
    //销售单状态
    SALE = "sale",
    //销售退货状态
    SALE_RETURN = "sale-return-status",
    // 结算类型
    SETTLE_TYPE = "payment-type",//之前"settle-type",
    //单据类型
    TRADE_TYPE = "trade-type",
    //维修单状态
    MAINTENANCE = "maintenance",
    //维修退单状态
    MAINTENANCE_RETURN = "maintenance.return",
    //车辆品牌
    VEHICLE_BRAND = "vehicle-brand",
    //服务性质
    SERVICE_TYPE = "service-nature",//之前"service-type",
    //服务地点
    SERVICE_ADDRESS = "service-address",
    //三包单位 
    CLAIMUNIT = "claim-unit",
    //预约状态
    APPOINTMENT = "appointment",
    //盘点单状态
    STOCKTAKING = "stocktaking",
    //收款人
    PAYEE = "payee",
    //税率
    TAX = "tax",
    //组织机构
    ORG = "cm-organization",
    //门店
    SHOP = "cm-shop",
    //门店类型
    SHOP_TYPE = "shop-type",
    //经济实体
    BE = "cm-business-entity",
    //结算方
    SETTLE_PARTY = "settle-party",
    //销售订单状态
    SALE_ORDER = "sale-order",
    // 销售订单(已开单)
    SALE_ORDER_CREATE = "sale-order.create",
    // 销售订单(已作废)
    SALE_ORDER_CHANGE = "sale-order.change",
    // 销售订单(已转接)
    SALE_ORDER_TRANSFER = "sale-order.transfer",
    //回访单状态
    VISIT_STATUS = "visit-status",
    //回访方式
    RETURN = "return",
    //
    //账户类型 （配件返利）
    ACC_TYPE_REBATE = "account-type.rebate",
    //账户类型 （油品返利）
    ACC_TYPE_REBATE_OIL = "account-type.rebate-oil",
    //结算类型
    PAYEE_TYPE = "settle-type",
}

export const sourceAppOrBranch = {
    sourceApp: "vrm-sa",
    branch: "vrm-sa"
}
export const orgCodeOrName = {
    orgCode: "vrm-sa",
    orgName: "vrm-sa"
}